import { validateYupSchema, yupToFormErrors } from "formik";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getValidationErrors = async <T>(formValues: any, validationSchema: any) => {
  try {
    await validateYupSchema(formValues, validationSchema);
  } catch (err) {
    return yupToFormErrors<T>(err);
  }
};
